import { CountryGroup } from '../../../../../../../../../types/countryGroup'

export const getDisplayTitle = (field: CountryGroup) => field.name
